import { z } from 'zod';

const ChargesSchema = z.object({
  charges: z.number().optional().nullable(),
  currency: z.string().optional().nullable(),
});

const ChargesImportSchema = z.object({
  CustomsCharges: ChargesSchema.optional(),
  VATcharges: ChargesSchema.optional(),
});

export const ValuationInformationTaxesSchema = z.object({
  deliveryTerms: z
    .object({
      incotermCode: z.string().optional(),
      location: z.string().optional(),
      country: z.string().optional(),
    })

    .optional(),
  valuationMethod: z.string().optional(),
  chargesimport: ChargesImportSchema.optional(),
  globalChargesimport: ChargesImportSchema.optional(),
  valuationAdjustment: z.object({ valuationIndicators: z.string().optional() }).optional(),
});

export type ValuationInformationTaxesDto = z.infer<typeof ValuationInformationTaxesSchema>;
